"use client";

import Link from "next/link";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Container,
} from "@mui/material";
import { BlogType } from "@/types/blog.type";
import routes from "@/app.route";
import { format } from "date-fns";
import { PaginationType } from "@/types/pagination.type";
import Pagination from "@/components/pagination";

export default function Blogs({
  blogs,
  links,
}: {
  blogs: BlogType[];
  links: PaginationType;
}) {
  return (
    <main>
      <Container sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Our Blogs
        </Typography>

        <Grid container spacing={3}>
          {blogs.map((blog, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
              <Link href={routes.blog.url.replace(":slug", blog.handle)}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    boxShadow: 3,
                    "&:hover": { boxShadow: 8 },
                  }}
                >
                  <CardMedia
                    component="img"
                    image={blog.featured_image ?? undefined}
                    alt={blog.title}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    {blog.created_at && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                      >
                        {format(blog.created_at, "MMM dd, yyyy")}
                      </Typography>
                    )}
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      {blog.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>

        <Pagination links={links} />
      </Container>
    </main>
  );
}
